import React from 'react';
import OrganizationModal from 'shared/components/OrganizationModal';
import YearsFormModal from './YearsForm';
import { CompanySetupEnum } from 'enums/CompanySetupEnums';
import styles from './addLocations.module.scss';
import { InitialValuesYears } from './constants';

interface LocationBoundaryModalProps {
  index: number;
  openModalIndex: number | null;
  handleModalIndex: () => void;
  initialValuesYears: {
    [key: number]: InitialValuesYears;
  };
  setFieldValue: (field: string, value: { year: string | number; share_percentage: number }[]) => void;
  setOpenModalIndex: React.Dispatch<React.SetStateAction<number | null>>;
  setInitialValuesYears: React.Dispatch<React.SetStateAction<{}>>
}

const LocationBoundaryModal: React.FC<LocationBoundaryModalProps> = ({
  index,
  openModalIndex,
  handleModalIndex,
  initialValuesYears,
  setFieldValue,
  setOpenModalIndex,
  setInitialValuesYears,
}) => {
  return (
    <OrganizationModal
      title={`Location ${index + 1} - Organizational boundary details`}
      visible={openModalIndex === index}
      onClose={handleModalIndex}
      children={
        <>
          <div className={styles.subtitle}>{CompanySetupEnum.EQUITY_TEXT}</div>
          <YearsFormModal
            index={index}
            initialValuesYears={initialValuesYears}
            setFieldValue={setFieldValue}
            setOpenModalIndex={setOpenModalIndex}
            setInitialValuesYears={setInitialValuesYears}
          />
        </>
      }
    />
  );
};

export default LocationBoundaryModal;
